import { Flex, Table } from 'antd'
import { BudgetRequest } from 'src/pages/budget/budgetRequests/types'
import {
  FilterTable,
  getRequestListColumns,
} from 'src/pages/budget/budgetRequests/components'
import { filtersChangedBudgetListOwnApprove } from 'src/pages/budget/budgetRequests/model'
import { PAGE_SIZE } from 'src/pages/budget/budgetCategories/const'

type Props = {
  list: BudgetRequest[]
  filterList: BudgetRequest[]
}

export const OwnApproveTable = ({ list, filterList }: Props) => {
  return (
    <Flex vertical gap="middle" style={{ width: '100%' }}>
      <Flex justify="space-between">
        <FilterTable
          fields={['articleName', 'products', 'searchText']}
          onChange={filtersChangedBudgetListOwnApprove}
          list={list}
        />
      </Flex>
      <Table
        dataSource={filterList}
        tableLayout="fixed"
        // rowSelection={{
        //   type: 'checkbox',
        //   selectedRowKeys,
        //   onChange: (keys) => setSelectedRowKeys(keys),
        // }}
        pagination={
          filterList.length > PAGE_SIZE
            ? {
                total: filterList?.length,
                defaultPageSize: PAGE_SIZE,
                showSizeChanger: true,
                position: ['bottomCenter'],
              }
            : false
        }
        columns={getRequestListColumns([
          'id',
          'articleName',
          'itemName',
          'description',
          'amount',
          'productIds',
          'status',
          'actionOwnApprove',
        ])}
        rowKey={(record) => record.id}
        rowClassName={(_, index) =>
          `ant_table_row_height ${index % 2 ? 'even-row' : 'odd-row'}`
        }
      />
    </Flex>
  )
}
